module.exports = "../../static/img/Kenvue.d74bc30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpg/Kenvue.png
// module id = 281L
// module chunks = 1